import { render, staticRenderFns } from "./FeaturesHero.vue?vue&type=template&id=afd0b2a4&scoped=true&"
import script from "./FeaturesHero.vue?vue&type=script&lang=js&"
export * from "./FeaturesHero.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesHero.vue?vue&type=style&index=0&id=afd0b2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd0b2a4",
  null
  
)

export default component.exports